<ng-content select="[versionInfoHeader]">
  <div class="flex items-center text-neutral-500">
    <strong class="text-neutral-900 text-sm">Version</strong>
    <div class="ml-auto flex items-center gap-1">
      @if (compareVersionsAction().visible) {
        <button
          [disabled]="!compareVersionsAction().enabled"
          [attr.data-testId]="compareVersionsAction().testId"
          [pTooltip]="compareVersionsAction().label"
          (click)="onCompareVersions()"
          class="flx-ds secondary small icon-btn"
          tooltipStyleClass="text-xs"
          tooltipPosition="bottom"
          flxButton
          icon="center"
        >
          <i
            [class]="compareVersionsAction().icon"
            flxIcon
          ></i>
        </button>
      }
      @if (exportVersionAction().visible) {
        <button
          [disabled]="!exportVersionAction().enabled"
          [attr.data-testId]="exportVersionAction().testId"
          [pTooltip]="exportVersionAction().label"
          (click)="onExportVersion()"
          class="flx-ds secondary small icon-btn"
          tooltipStyleClass="text-xs"
          tooltipPosition="bottom"
          flxButton
          icon="center"
        >
          <i
            [class]="exportVersionAction().icon"
            flxIcon
          ></i>
        </button>
      }
    </div>
  </div>
</ng-content>
<div class="flex items-center gap-2 text-xs">
  @if (showDetails()) {
    <span>Version details:</span>
  }
  @if (applicationVersion().buildTag) {
    <flx-build-tag
      [buildTagVersion]="applicationVersion().buildTag"
      size="xs"
    />
  } @else {
    <div class="grid grid-cols-[max-content_185px] w-full items-center gap-1">
      <flx-branch-state
        [status]="applicationVersion().status"
        [isArchived]="applicationVersion().branchArchived"
      />
      @if (mergedVersionState()) {
        <flx-branch-merge-state
          [mergedFromBranchName]="mergedVersionState().mergedFromBranchName"
          [isMergedBranchArchived]="mergedVersionState().isMergedBranchArchived"
        />
      }
    </div>
  }
</div>
<div class="grid grid-cols-[auto_1fr] gap-2 items-center text-xs">
  Edited by:
  @let commitedBy = applicationVersion().committedBy ?? applicationVersion().contentModifiedBy;
  <div class="flex items-center gap-1">
    <span
      [pTooltip]="commitedBy.firstName + ' ' + commitedBy.lastName"
      class="commit-author text-neutral-900"
      tooltipStyleClass="text-xs"
    >
      {{ commitedBy | flxUserInitials }}
    </span>
    <span>{{
      applicationVersion().contentModifiedDate | flxDateFormat: 'dd MMM yyyy' : 'h:mm a' : ', '
    }}</span>
  </div>

  Version ID:
  <div class="flex items-center">
    <div class="truncate w-16">{{ applicationVersion().id }}</div>
    <button
      [cdkCopyToClipboard]="applicationVersion().id"
      (cdkCopyToClipboardCopied)="onCopyToClipboardSuccess($event)"
      class="flx-ds small neutral -my-2"
      variant="text"
      icon="center"
      flxButton
      data-testid="copy-app-version-id-btn"
    >
      <i
        [ngClass]="copiedTextToClipboard() ? 'ph-check-circle' : 'ph-copy'"
        [class.text-green-300]="copiedTextToClipboard()"
        class="ph"
        flxIcon
      ></i>
    </button>
  </div>
</div>

@if (applicationVersion().committedBy && !showDetails() && viewCommitDetailsAction().visible) {
  <button
    [disabled]="!viewCommitDetailsAction().enabled"
    [attr.data-testId]="viewCommitDetailsAction().testId"
    (click)="onViewCommitDetails()"
    class="flx-ds secondary neutral small justify-start"
    flxButton
    icon="left"
    pTooltip="View commit message"
    tooltipStyleClass="text-xs"
  >
    <i
      [class]="viewCommitDetailsAction().icon"
      flxIcon
    ></i>
    <div class="flex items-center grow truncate">
      <span class="truncate">{{ applicationVersion().commitMessage }}</span>
      <i
        class="ph ph-caret-right"
        class="ml-auto"
        flxIcon
      ></i>
    </div>
  </button>
}

@if (applicationVersion().committedBy && showDetails()) {
  <hr class="my-2" />
  <div class="flex flex-col gap-2 text-xs min-h-0 flex-1">
    <strong class="text-sm text-neutral-900">Commit message:</strong>
    <p data-testId="commit-message-details">{{ applicationVersion().commitMessage }}</p>
    <strong class="text-sm text-neutral-900">Description:</strong>
    <p
      class="whitespace-pre-wrap break-words min-h-0 flex-1 overflow-y-auto"
      data-testId="commit-description-details"
    >
      {{ applicationVersion().commitDescription || '—' }}
    </p>
  </div>
}
